import React, { useState, useEffect } from 'react';
import { api } from '../../api';
import toast from 'react-hot-toast';
import AddFingerprintModal from '../devices/AddFingerprintModal'; // NEW: Import the new modal

const EditEmployeeModal = ({
  user,
  person,
  onClose,
  onEmployeeUpdated,
  propertyId,
}) => {
  const [firstName, setFirstName] = useState(person.first_name || '');
  const [lastName, setLastName] = useState(person.last_name || '');
  const [email, setEmail] = useState(person.email || '');
  const [phone, setPhone] = useState(person.phone || '');
  const [role, setRole] = useState(person.role || 'Housekeeper');
  const [isActive, setIsActive] = useState(!!person.is_active);
  const [isLoading, setIsLoading] = useState(false);

  // NEW: State for the "Add Fingerprint" feature
  const [isAddFingerModalOpen, setIsAddFingerModalOpen] = useState(false);
  const [devices, setDevices] = useState([]);
  const [selectedDeviceId, setSelectedDeviceId] = useState('');

  const canEditSensitiveFields =
    user.role === 'SuperAdmin' || user.userId !== person.id;
  
  // NEW: Fetch devices for this property so the user can select one for enrollment
  useEffect(() => {
    if (person.role === 'Housekeeper') {
      const fetchDevices = async () => {
        try {
          const deviceData = await api.getDevices({ propertyId });
          setDevices(deviceData || []);
          // Auto-select the first device if one exists
          if (deviceData && deviceData.length > 0) {
            setSelectedDeviceId(deviceData[0].id);
          }
        } catch (error) {
          toast.error("Could not load devices for this property.");
        }
      };
      fetchDevices();
    }
  }, [propertyId, person.role]);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const updatedData = {
      first_name: firstName,
      last_name: lastName,
      email,
      phone,
      role,
      is_active: isActive,
      propertyId: propertyId,
    };

    try {
      await api.updateWorkforcePerson(person.id, updatedData);
      toast.success('User updated successfully!');
      onEmployeeUpdated();
      onClose();
    } catch (err) {
      toast.error(err.message || 'Failed to update user.');
    } finally {
      setIsLoading(false);
    }
  };

  // NEW: Find the full device object based on the selected ID
  const selectedDeviceForAction = devices.find(d => d.id === parseInt(selectedDeviceId));

  return (
    <>
      <div className="modal-overlay">
        <div className="modal-content">
          <h2>Edit {person.first_name} {person.last_name}</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">First Name</label>
                <input type="text" className="form-input" value={firstName} onChange={(e) => setFirstName(e.target.value)} required />
              </div>
              <div className="form-group">
                <label className="form-label">Last Name</label>
                <input type="text" className="form-input" value={lastName} onChange={(e) => setLastName(e.target.value)} required />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Email Address</label>
                <input type="email" className="form-input" value={email} onChange={(e) => setEmail(e.target.value)} required />
              </div>
              <div className="form-group">
                <label className="form-label">Phone Number</label>
                <input type="tel" className="form-input" value={phone} onChange={(e) => setPhone(e.target.value)} required />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Role</label>
                {person.role === 'Housekeeper' ? (
                  <select className="form-input" value={role} disabled={true}>
                    <option value="Housekeeper">Housekeeper</option>
                  </select>
                ) : (
                  <select className="form-input" value={role} onChange={(e) => setRole(e.target.value)} disabled={!canEditSensitiveFields}>
                    {user.role === 'SuperAdmin' && (<option value="SuperAdmin">Super Admin</option>)}
                    <option value="Owner">Owner</option>
                    <option value="Manager">Manager</option>
                    <option value="Accountant">Accountant</option>
                  </select>
                )}
              </div>
              <div className="form-group">
                <label className="form-label">Status</label>
                <div className="toggle-switch-container">
                  <label className="toggle-switch">
                    <input type="checkbox" checked={isActive} onChange={() => setIsActive(!isActive)} disabled={!canEditSensitiveFields}/>
                    <span className="slider"></span>
                  </label>
                  <span className="toggle-label">{isActive ? 'Active' : 'Inactive'}</span>
                </div>
              </div>
            </div>

            {/* --- NEW BIOMETRIC ENROLLMENT SECTION --- */}
            {person.role === 'Housekeeper' && (
                <div className="form-section">
                    <h3 className="form-section-title">Biometric Enrollment</h3>
                    <div className="form-group">
                        <label className="form-label">Enroll on Device</label>
                        <select
                            className="form-input"
                            value={selectedDeviceId}
                            onChange={(e) => setSelectedDeviceId(e.target.value)}
                            disabled={devices.length === 0}
                        >
                            {devices.length > 0 ? (
                                devices.map(device => <option key={device.id} value={device.id}>{device.name} ({device.serial_number})</option>)
                            ) : (
                                <option>No devices found for this property</option>
                            )}
                        </select>
                    </div>
                    <button
                        type="button"
                        className="button button-secondary"
                        onClick={() => setIsAddFingerModalOpen(true)}
                        disabled={!selectedDeviceId}
                    >
                        Enroll Another Fingerprint
                    </button>
                </div>
            )}
            {/* --- END NEW SECTION --- */}

            <div className="modal-actions">
              <button type="button" className="button button-secondary" onClick={onClose} disabled={isLoading}>Cancel</button>
              <button type="submit" className="button action-button" disabled={isLoading}>
                {isLoading ? 'Saving...' : 'Save Changes'}
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* NEW: Render the AddFingerprintModal when its state is true */}
      {isAddFingerModalOpen && (
        <AddFingerprintModal
            device={selectedDeviceForAction}
            person={person}
            onClose={() => setIsAddFingerModalOpen(false)}
        />
      )}
    </>
  );
};

export default EditEmployeeModal;